import { computed } from 'vue';
import { useNutzv2InputStore } from '@/features/Sparten/nutzv2/useInputStore';
import { WKZ } from '@/features/Sparten/shared/types/kfz/types';

export const hasNutzKilometerstand = computed(
  (): boolean =>
    useNutzv2InputStore().allgemein !== undefined &&
    useNutzv2InputStore().allgemein.wkz !==
      WKZ.ANHAENGER_PRIVAT_UND_WERKVERKEHR &&
    useNutzv2InputStore().allgemein.wkz !== WKZ.ANHAENGER_GEWERBLICHER_VERKEHR,
);
